<template>
  <div>
      <div v-if="!excluding"><i>Vänta medan vi startar igång Z-Wave exkluderingen...</i></div>

      <div v-if="excluding && !removed">
        <h3>Du kan nu exkludera...</h3>
        <p>Exkluderingsläget är aktiverat vilket innebär att du nu kan exkludera din enhet. Oftast gör man detta genom att trycka tre gånger snabbt på Z-Wave enheten.</p>
        
        <div style="padding-left:45%;padding-top:1em;">
          <half-circle-spinner :animation-duration="1000" :size="90" color="#033873" />
        </div>
      </div>

      <div v-if="removed">
        <h3>Klart!</h3>

        <span v-if="removedNode">
          <p>Enheten {{ removedNode.name }} har tagits bort från din Nexa Bridge. Du kommer nu skickas vidare.</p>
        </span>
        <span v-else>
          <p>En enhet som inte var inkluderad på din Bridge har tagits bort och återställts, det är nu fritt fram att inkludera den på Bridgen.</p>
        </span>

        <div style="text-align:center;">
          <img src="../assets/check2.gif" width="350">
        </div>
      </div>
  </div>
</template>

<script>
  import { HTTP } from '../http.js'
  import { eventbus } from '../eventbus.js';
  import { HalfCircleSpinner } from 'epic-spinners'

  export default {
    name: 'zwave_exclude',
    components: {
      HalfCircleSpinner
    },
    data () {
      return {
        excluding: false,
        removed: false,
        removedNode: null
      }
    },
    created () {
      eventbus.$once('removeNodeStarted', () => this.excluding = true)

      eventbus.$once('nodeRemoved', (json) => {
        this.removed = true
        this.removedNode = this.$root.data.nodes.find(node => node.id === json.id) 
        
        // Leta upp index på noden och om vi har en nod så
        // tar vi bort den från listan.
        const indexOfNode = this.$root.data.nodes.findIndex(node => node.id === json.id)
        if (indexOfNode) {
          this.$root.data.nodes.splice(indexOfNode, 1)
        }
        
        setTimeout(() => {
          this.$router.replace({
            name: 'enheter'
          })
        }, 2000)
      })
      
      HTTP.post('nodeops/removeNodeAbort')
      .then(res => res.data)
      .then(json => {
        
        HTTP.post('nodeops/removeNode')
        .then(res => res.data)
        .then(json => {
          
        })
      })
    },
    
    methods: {
  
    },
  
    // När vyn försvinner
    destroyed () {
      HTTP.post('nodeops/removeNodeAbort')
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/zwave_exclude.vue